/*
License

Copyright (c) 2022 Chukwubuikem Ume-Ugwa

Permission is hereby witheld, any person obtaining a copy
of this software and associated documentation files (the "Software"), cannot
use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software. These restrictions can be only lifted with
a written permission from Chukwubuikem Ume-Ugwa.
*/
import { useState } from 'react';

export function useStorage(key, dvalue, storage = sessionStorage) {
  const loadValue = dvalue => {
    const val = storage.getItem(key);
    return val === null ? dvalue : JSON.parse(val);
  };

  const [value, setValue] = useState(loadValue(dvalue));
  const cacheValue = (key, value) => {
    storage.setItem(key, JSON.stringify(value));
    setValue(value);
  };

  return [value, cacheValue];
}

export function storageAdapter(key, dvalue, storage = sessionStorage) {
  const loadValue = dvalue => {
    const val = storage.getItem(key);
    return val === null ? dvalue : JSON.parse(val);
  };

  const cacheValue = (key, value) => {
    storage.setItem(key, JSON.stringify(value));
  };

  const removeValue = key => {
    storage.removeItem(key);
  };

  const value = loadValue(dvalue);
  return [value, cacheValue, removeValue];
}
